import React from 'react'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { OurPublications } from './our-publication'

export const OurPublicationRegistration = createRegisterableComponent('our-publications', () => (
    <OurPublications />
))
